import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScrollContainerComponent } from './scroll-container.component';

@NgModule({
  declarations: [
    ScrollContainerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    ScrollContainerComponent
  ]
})
export class ScrollContinerModule {
}
